import Date from '../../../../components/Date/Date'
import {formatPrice} from '../../../../utils/common'
import Initials from '../../../../components/Initials'
import {Link} from 'react-router-dom'

const OrderReportTableRow = ({row}: any) => {
  return (
    <tr>
      <td>
        <Date date={row.orderDate} isDynamicFormat={false} />
      </td>
      <td>
        <Link
          to={{
            pathname: '/orders/all-orders/summary',
            search: `?id=${row.orderId}`,
          }}
          className='text-dark text-hover-primary text-decoration-underline'
          target='_blank'
        >
          #{row.orderId}
        </Link>
      </td>
      <td>
        <Link
          to={{
            pathname: `/customers/details/${row.customerId}`,
          }}
          target='_blank'
          className='d-flex align-items-center flex-grow-1 text-start'
        >
          <div className='symbol symbol-circle symbol-35px me-3'>
            <Initials text={row.customerName[0]} />
          </div>
          <div className='d-flex flex-column'>
            <div className='align-items-center text-dark fw-semibold'>{row.customerName}</div>
            <div className='align-items-center text-muted'>{row.customerEmail}</div>
          </div>
        </Link>
      </td>
      <td>{row.customerGroupName}</td>
      <td>{row.salesRepName}</td>
      <td>{formatPrice(row.subtotal, false)}</td>
      <td>{formatPrice(row.couponDiscounts, false)}</td>
      <td>{formatPrice(row.tax, false)}</td>
      <td>{formatPrice(row.shipping, false)}</td>
      <td>{formatPrice(row.total, false)}</td>
      <td>{formatPrice(row.cost, false)}</td>
      {/* <td>{formatPrice(row.totalSale, false)}</td> */}
      <td>{formatPrice(row.profit, false)}</td>
      <td>{row.profitPercentage}%</td>
      <td className='text-end'>{row.contributedProfitPercentage}%</td>
    </tr>
  )
}

export default OrderReportTableRow
